import { render, staticRenderFns } from "./PlusReceptModal.vue?vue&type=template&id=3476ac32&scoped=true"
import script from "./PlusReceptModal.vue?vue&type=script&lang=ts"
export * from "./PlusReceptModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3476ac32",
  null
  
)

export default component.exports